import { ActionTree } from 'vuex';

import api from '@/api';

import Pagination from '@/store/models/pagination';
import { RootState, ErrorMessages, RootActions, ListStatus } from '@/store/types';

import SendGridEmail from './sendgrid_email';
import { SendGridEmailState, SendGridEmailActions, SendGridEmailMutations } from './types';
import { enhanceErrorWithMessage } from '@/utils/errors';

export const actions: ActionTree<SendGridEmailState, RootState> = {
  [SendGridEmailActions.LOAD](
    { commit, dispatch },
    { search, email_type, status, from, to, page = 1, sort, direction } = {},
  ): Promise<void> {
    commit(SendGridEmailMutations.SET_STATUS, ListStatus.Loading);

    return api.sendgrid_emails
      .list({ search, email_type, status, from, to, page, sort, direction })
      .then((response) => response.data)
      .then((response) => {
        const emails = response.data.map((email) => SendGridEmail.fromJSON(email));
        commit(SendGridEmailMutations.SET_LIST_PAGINATION, Pagination.fromJSON(response));
        commit(SendGridEmailMutations.SET_LIST, emails);
        commit(SendGridEmailMutations.SET_STATUS, ListStatus.Loaded);
      })
      .catch((error) => {
        enhanceErrorWithMessage(error, ErrorMessages.DATA_LOAD_ERROR);

        commit(SendGridEmailMutations.SET_STATUS, ListStatus.Failed);
        return dispatch(RootActions.ERROR, error, { root: true });
      });
  },

  [SendGridEmailActions.LOAD_SUMMARY]({ commit }, { email_type, from, to } = {}): Promise<void> {
    return api.sendgrid_emails
      .summary({ email_type, from, to })
      .then((response) => response.data)
      .then((summary) => {
        commit(SendGridEmailMutations.SET_SUMMARY, {
          sends: Number(summary.sends || 0),
          delivered: Number(summary.delivered || 0),
          uniqueOpens: Number(summary.unique_opens || 0),
          uniqueClicks: Number(summary.unique_clicks || 0),
          totalOpens: Number(summary.total_opens || 0),
          totalClicks: Number(summary.total_clicks || 0),
          deliveredRate: Number(summary.delivered_rate || 0),
          openRate: Number(summary.open_rate || 0),
          clickRate: Number(summary.click_rate || 0),
        });
      })
      .catch(() => {
        // Summary is supplementary; never block the list view on it.
        commit(SendGridEmailMutations.SET_SUMMARY, null);
      });
  },
};

export default actions;
